import React, {Component} from 'react';
import PropTypes from 'prop-types';
import postscribe from "postscribe";
import IframeResizer from "iframe-resizer-react";
import './FormAssembly.scss';

class FormAssembly extends Component {

    static propTypes = {
        // eslint-disable-next-line react/no-unused-prop-types
        id: PropTypes.string.isRequired,
        styles: PropTypes.string,
        reference: PropTypes.string,
    };

    static defaultProps = {
        styles: '',
        reference: ''
    };

    state = {
        scriptsLoaded: false,
        header: null,
        body: null
    }

    componentDidMount() {
        this.handleLoading();
    }

    handleLoading = () => {
        const element = document.getElementById(`formassembly${this.props.id}`);

        const assemblyIdNumeric = parseInt(this.props.id, 10);

        // Only Load Scripts for non-numeric Form IDs
        if (assemblyIdNumeric && !this.state.scriptsLoaded) this.setState({scriptsLoaded: true});

        // Detect if Script is already loaded on the page to prevent duplicate loading.
        const scriptAlreadyLoaded = document.querySelector('script[src="https://tfaforms.com/js/iframe_resize_helper.js"]');

        if (element && !this.state.scriptsLoaded) {
            if (!scriptAlreadyLoaded) postscribe(`#formassembly${this.props.id}`, '<script src="https://tfaforms.com/js/iframe_resize_helper.js"></script>');
            this.setState({scriptsLoaded: true});
        }
    };

    render() {
        const iframeHost = "/";
        let iframePath = `${iframeHost}formassembly.php?id=${this.props.id}`;
        if (this.props.styles) {
            iframePath += `&style=${this.props.styles}`;
        }

        if (this.props.reference) {
            iframePath += `&reference=${this.props.reference}`;
        }

        return (
            <div id={`formassembly${this.props.id}`} className="formAssemblyOuter">
                {this.state.scriptsLoaded ? (
                <React.Fragment>
                    {isNaN(this.props.id) ? (
                        <iframe src={iframePath} style={{border: 0, width: '1px', minWidth: '100%'}} title={this.props.id}/>
                    ) : (
                        <IframeResizer src={iframePath} style={{border: 0, width: '1px', minWidth: '100%'}}/>
                    )}
                </React.Fragment>
                ) : null}
            </div>
        );
    }
}

export default FormAssembly;




// WEBPACK FOOTER //
// ./frontend/components/FormAssembly/FormAssembly.jsx